export module SubstitutionBoardEnumerations {

export class EnumerationModel {
    constructor(public code: string, public name: string) {
    }
}

export class ActivityType {
    static readonly groupClass = new EnumerationModel('groupclass', 'GroupClass');
}

export class SubstitutionProposalStatus {
    static readonly pending = new EnumerationModel('pending', 'Pending');
    static readonly approved = new EnumerationModel('approved', 'Approved');
    static readonly rejectedByManager = new EnumerationModel('rejectedbymanager', 'RejectedByManager');
    static readonly cancelledByProvider = new EnumerationModel('cancelledbyprovider', 'CancelledByProvider');
    static readonly cancelledByRequest = new EnumerationModel('cancelledbyrequest', 'CancelledByRequest');
}

export class SubstitutionRequestStatus {
    static readonly open = new EnumerationModel('open', 'Open');
    static readonly closed = new EnumerationModel('closed', 'Closed');
    static readonly cancelled = new EnumerationModel('cancelled', 'Cancelled');
    static readonly overdue = new EnumerationModel('overdue', 'Overdue');
}
}
